import { render, staticRenderFns } from "./iframe_test.vue?vue&type=template&id=52415172&scoped=true"
import script from "./iframe_test.vue?vue&type=script&lang=js"
export * from "./iframe_test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52415172",
  null
  
)

export default component.exports